define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var BulkEditCustomerUserModel = /** @class */ (function () {
        function BulkEditCustomerUserModel(data) {
            this.BulkEditCouterPath = ko.observable();
            this.EnableCouterPath = ko.observable();
            this.EnableLdap = ko.observable();
            this.EnableCPLogin = ko.observable();
            this.ResetCouterPathPasswords = ko.observable();
            this.CustomerProfileId = ko.observable();
            this.CustomerUsers = ko.observableArray();
            this.CustomerUserIds = ko.observableArray();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, BulkEditCustomerUserModel.Mapping, self);
            }
        }
        BulkEditCustomerUserModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new BulkEditCustomerUserModel(options.data);
            }
        };
        return BulkEditCustomerUserModel;
    }());
    return BulkEditCustomerUserModel;
});
//# sourceMappingURL=BulkEditCustomerUserModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/BulkEditCustomerUserModel.js
// module id = 173
// module chunks = 2